import { createContext } from 'react';

// The game as the player looking sees it, for parts that work something out from it wherever they are drawn (e.g. a
// card's hover showing what it would score now): { gameState, viewer (the player looking), colors (each player's) }, or
// null outside a game
export const GameStateContext = createContext(null);
